import { createFileRoute } from '@tanstack/react-router';
import { AreasList } from '@/components/Admin/AreasList/AreasList';

export const Route = createFileRoute('/_adminLayout/admin/areas/')({
  component: AreasList,
});
